var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "help-a",
    d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,3.81818182 C7.48130659,3.81818182 3.81818182,7.48130659 3.81818182,12 C3.81818182,16.5186934 7.48130659,20.1818182 12,20.1818182 C16.5186934,20.1818182 20.1818182,16.5186934 20.1818182,12 C20.1818182,7.48130659 16.5186934,3.81818182 12,3.81818182 Z M11.3571757,15.9026302 C11.7121977,15.5476081 12.2878023,15.5476081 12.6428243,15.9026302 C12.9978464,16.2576523 12.9978464,16.8332568 12.6428243,17.1882789 C12.2878023,17.543301 11.7121977,17.543301 11.3571757,17.1882789 C11.0021536,16.8332568 11.0021536,16.2576523 11.3571757,15.9026302 Z M12.5420309,6.59373267 C14.2896573,6.89349707 15.566276,8.410023 15.5636435,10.1818182 C15.5636435,11.3452048 14.8743766,12.2642209 13.7951831,12.9836823 C13.2052562,13.3769665 12.6256895,13.6345514 12.2147522,13.7715304 C11.7384401,13.9303009 11.2236038,13.6728826 11.0648333,13.1965704 C10.9060627,12.7202582 11.1634811,12.205422 11.6397932,12.0466515 C11.6987645,12.0269944 11.8210017,11.9804279 11.9841931,11.9078984 C12.2597415,11.7854326 12.5349504,11.6386547 12.7866381,11.4708631 C13.411992,11.053961 13.7454576,10.6093407 13.7454586,10.1804659 C13.7467774,9.29389033 13.1084671,8.53562617 12.2346533,8.38574388 C11.3608396,8.23586159 10.5063264,8.73806651 10.2121222,9.57440321 C10.0455112,10.0480298 9.52649609,10.2969151 9.05286952,10.130304 C8.57924295,9.96369302 8.33035767,9.44467791 8.49696869,8.97105134 C9.08537702,7.29837793 10.7944034,6.29396809 12.5420309,6.59373267 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "help-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#help-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#help-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    mask: "url(#help-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.26997300f17aef600da3ee345a1fae09.svg";
export { ForwardRef as ReactComponent };